import { Divider, Stack, Typography } from '@mui/material';
import React from 'react';
import { FieldValues } from 'react-hook-form';

import { TSewCustomerPartyFieldsProps } from '@/backoffice/features/tenants/components/sew-customer-parties/sew-customer-party-fields.types';
import { FormInput } from '@/shared/components/ui/form/components/form-input/form-input';

export const SewCustomerPartyFields: React.FC<TSewCustomerPartyFieldsProps> = ({
  party,
  nameLabel,
  idLabel,
  title,
  namePlaceholder,
  idPlaceholder,
  nameHint,
  idHint,
}) => (
  <Stack gap="1rem">
    <Divider />
    {title && <Typography variant="h7">{title}</Typography>}
    <FormInput<FieldValues>
      name={`metaData.${party.nameKey}`}
      label={nameLabel}
      placeholder={namePlaceholder}
      hint={nameHint}
      required
    />
    <FormInput<FieldValues>
      name={`metaData.${party.idKey}`}
      label={idLabel}
      placeholder={idPlaceholder}
      hint={idHint}
      required
    />
  </Stack>
);
